// extracted by mini-css-extract-plugin
export default {"heading":"EA-z","corrected":"FA-z","redirectVerbiageContainer":"GA-z","redirectVerbiageText":"HA-z"};